import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ComponentStateService {
  private states = new Map<string, BehaviorSubject<boolean>>();

  constructor() { }

  // Get or create a state observable
  getState(key: string): Observable<boolean> {
    if (!this.states.has(key)) {
      this.states.set(key, new BehaviorSubject<boolean>(true));
    }
    return this.states.get(key)!.asObservable();
  }

  // Set state value
  setState(key: string, value: boolean): void {
    if (!this.states.has(key)) {
      this.states.set(key, new BehaviorSubject<boolean>(value));
    } else {
      this.states.get(key)!.next(value);
    }
  }

  // Toggle state value
  toggleState(key: string): void {
    // Split the key string into individual keys
    const keys = Array.isArray(key) ? key[0].split(';') : key.split(';');
    
    // Toggle each key
    keys.forEach((singleKey: string) => {
      if (!this.states.has(singleKey)) {
        this.states.set(singleKey, new BehaviorSubject<boolean>(true));
      } else {
        const currentState = this.states.get(singleKey)!;
        currentState.next(!currentState.value);
      }
    });
  }

  // Get current state value without subscribing
  getCurrentState(key: string): boolean {
    if (!this.states.has(key)) {
      this.states.set(key, new BehaviorSubject<boolean>(false));
    }
    return this.states.get(key)!.value;
  }

  // Clear a specific state
  clearState(key: string): void {
    if (this.states.has(key)) {
      const state = this.states.get(key)!;
      state.complete();
      this.states.delete(key);
    }
  }

  // Clear all states
  clearAllStates(): void {
    this.states.forEach(state => state.complete());
    this.states.clear();
  }
}
